import {
  Button,
  Modal,
  notification,
  Popconfirm,
  Radio,
  Space,
  Table,
  Typography,
  Form,
} from "antd";
import { useEffect } from "react";
import API_SERVICE from "shared/services/api-service";
import { useState } from "react";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { ReactComponent as IconApprove } from "../../../../assets/images/apporveIcon.svg";
import { useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import FormSelect from "components/FormSelect/FormSelect";


const { Text } = Typography;

const BulkupdateMapImport: React.FunctionComponent<{
  setActiveStepKey: any;
  setBulkUploadExecuteData: any;
  setStatus: any;
}> = (props) => {
  const { setActiveStepKey, setBulkUploadExecuteData } = props;
  var uploadId = null as any;
  var entityType = null as any;
  const [bulkUploadMapData, setBulkUploadMapData] = useState([] as any);
  const [isopenMap, setIsopenMap] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showLenderList, setShowLenderList] = useState(false)
  const [successfullMapping, setSuccessfullMapping] = useState(false)
  const [lenderBulkLoginData, setLenderBulkLoginData] = useState([] as any);
  const [selectedLenderId, setSelectedLenderId] = useState("");
  const [loginOptionModal, setLoginOptionModal] = useState(false);
  const [updateStatusType, setUpdateStatusType] = useState("");
  const [loanProductId, setLoanProductId] = useState("");
  const { appColors }: any = useSelector((state: RootState) => state.common);
  const { setStatus } = props;
  const btnPrimaryStyles: any = {"--btnColor": appColors?.appPrimaryColor ?? ""}
  const btnDefaultBorderStyle: any = {'--borderColor': appColors?.appSecondaryColor ?? ""};
  
  const [form] = Form.useForm();

  useEffect(() => {
    BulkUploadMap();
  }, []);

  const BulkUploadMap = () => {
    uploadId = localStorage.getItem("uploadId");
    entityType = "BULK_LEAD_LOGIN";
    API_SERVICE.bulkUploadMap(uploadId, entityType)
      .then(({ data }) => {
        if (data) {
          notification.success({ message: "File Mapped Successfully" });
          setLoanProductId(data.payload.loanProductId) 
          setBulkUploadMapData(data.payload.columnHeaderBeans);
          setSuccessfullMapping(true) 
        }
      })
      .catch((e: any) =>{
        setSuccessfullMapping(false) 
        notification.error({ message: API_SERVICE.handleErrors(e) })
      });
  };

  const gotoSelectLenderList =() =>{
    setShowLenderList(successfullMapping)
    getBulkLoginLenderList()
  }

  const getBulkLoginLenderList = () => {
    API_SERVICE.getLendersForBulkLogin({ loanProductId })
    .then(({ data }) => {
      if (data) {
        const displayNameList = data?.payload?.map((listVal: any) => {
          return {
              key: listVal?.lenderInfoId,
              value: listVal?.lenderName,
              submissionType: listVal?.submissionType
          }
      });
      setLenderBulkLoginData(displayNameList);
      }
    });
  };

  const handleLenderChange = (values:any) =>{
    setSelectedLenderId(values.toString())
}

  
  const goToSuccessImportBulkUpload = (submissionType: string) => {
    uploadId = localStorage.getItem("uploadId");
    entityType = "BULK_LEAD_LOGIN";
    let lenderId = selectedLenderId;
    if (!lenderId) {
      notification.error({ message: "Please select Lender Name" });
      return;
    }
    setLoading(true);
    const body = {
      lenderId,
      submissionType,
    };
    API_SERVICE.bulkLoginUploadExecute(uploadId, entityType, body)
      .then(({ data }) => {
        if (data) {
          notification.success({ message: "File Uploaded Successfully" });
          setActiveStepKey(2);
          setIsopenMap(false);
          setBulkUploadExecuteData(data.payload);
          setStatus(data.payload?.status);
        }
      })
      .catch((e: any) =>
        notification.error({ message: API_SERVICE.handleErrors(e) })
      )
      .finally(() => setLoading(false));
  };

  const handleSubmit = () => {
    if (updateStatusType === "API" || updateStatusType === "LOGIN") {
      goToSuccessImportBulkUpload(updateStatusType);
      setLoginOptionModal(false);
    }
  };

  const columns = [
    {
      title: "DB column Name",
      dataIndex: "dbColumnName",
    },
    {
      title: "Excel column Name",
      dataIndex: "excelColumnName",
    },
    {
      title: "Mapped",
      dataIndex: "mapped",
      render: (_: any, recored: any) => (
        <Space className="action-button" size="middle">
          {recored.mapped ? (
            <Button
              className="green"
              size="small"
              type="primary"
              shape="circle"
              icon={<CheckOutlined />}
              // onClick={() => goToLeadDetails1(record)}
            />
          ) : (
            <Button
              className="red"
              size="small"
              type="primary"
              shape="circle"
              icon={<CloseOutlined style={{ color: "white" }} />}
              // onClick={() => goToLeadDetails1(record)}
            />
          )}
        </Space>
      ),
    },
  ];

  const btnRadioStyles: any = {
    "--borderColor": appColors?.appPrimaryColor ?? "",
  };

  const renderLoginUpdateStatus = () => {
    return (
      <Modal
        centered
        width={350}
        footer={null}
        visible={loginOptionModal}
        closable={false}
      >
        <div style={{ display: "grid", gap: "20px", marginTop: "20px" }}>
          <span>Select the Option</span>
          <Radio.Group
            onChange={(e) => setUpdateStatusType(e?.target?.value)}
            name="applicantType"
            className="dynamic-radio"
            style={btnRadioStyles}
          >
            <Space direction="vertical">
              <Radio value={"API"}>{"Send Case via API"}</Radio>
              <Radio value={"LOGIN"}>
                {"Update Status of an offline Case"}
              </Radio>
            </Space>
          </Radio.Group>
          <Space style={{ marginBottom: "20px" }}>
            <Button
              size="large"
              className="button-submit dynamic-btn-primary"
              style={customStylesBtnPrimary}
              // loading={loading}
              type="primary"
              onClick={handleSubmit}
            >
              Submit
            </Button>
            <Button
              size="large"
              className="button-submit dynamic-btn-default"
              style={btnDefaultBorderStyle}
              htmlType="button"
              onClick={() => setLoginOptionModal(false)}
            >
              Cancel
            </Button>
          </Space>
        </div>
      </Modal>
    );
  };

  const renderLenderListing = () => {
    

    const handleSubmit = () => {
      form.validateFields().then((values) => {
        const selectedLender = lenderBulkLoginData.find(
          (lender) => lender.key === values.lenderName
        );
        if (selectedLender?.submissionType === "API") {
          setLoginOptionModal(true);
        } else {
          goToSuccessImportBulkUpload("LOGIN");
        }
      }).catch((errorInfo) => {
        console.log('Validation Failed:', errorInfo);
      });
    };

    return (
      <Modal
        centered
        footer={false}
        width={420}
        title="Send To"
        visible={showLenderList}
        destroyOnClose
        closable={false}
      >
      <Form form={form} initialValues={{ lenderName: null }}>
        <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
          Note: If you proceed, successful records will be sent to the selected
          lender. Do you still want to Submit?
        </div>
        <div className="custom-select-padding-left">
          <FormSelect
            name="lenderName"
            isBorder
            isRequired
            requiredLabel="Lender Name"
            showSearch
            placeholder="Search with Lender Name"
            options={lenderBulkLoginData}
            optionFilterProp="children"
            onChange={handleLenderChange}
            smallLabel={(option) =>
              option.submissionType === "API" && (
                <span style={{ fontSize: "10px" }}>
                  <IconApprove /> API
                </span>
              )
            }
          />
        </div>
        <div>
          <Button
            type="primary"
            className="dynamic-btn-default-submit"
            style={btnPrimaryStyles}
            loading={loading}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
        <div>
          <Button
            htmlType="button"
            className="dynamic-btn-default-cancel"
            style={btnDefaultBorderStyle}
            onClick={() => setShowLenderList(false)}
          >
            Cancel
          </Button>
        </div>
        </Form>
      </Modal>
    );
  };

  const onClickCancel = () => {
    const uploadId = localStorage.getItem("uploadId");
    API_SERVICE.bulkUploadDelete(uploadId).then(({ data }) => {
      setActiveStepKey(0);
    });
  };

  const customStylesBtn: any = {
    "--borderColor": appColors?.appSecondaryColor ?? "",
    marginLeft: "10px",
  };
  const customStylesBtnPrimary: any = {
    "--btnColor": appColors?.appPrimaryColor ?? "",
    marginRight: "10px",
  };
  const customStyles: any = { "--bgColor": appColors?.appPrimaryColor ?? "" };

  return (
    <>
      {isopenMap && (
        <div className="content-box">
          <div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Text>
                <h4>Map Columns in your file to the Lead Database Fields</h4>
              </Text>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Text>
                Each column header below should be mapped to a contact
                properties. same of these have already been mapped based on
                their names.
              </Text>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}></div>

            <div style={{ marginTop: "20px" }}>
              <div style={{}}>
                <Table
                  columns={columns}
                  dataSource={bulkUploadMapData}
                  className="dynamic-pagination-checkbox"
                  style={customStyles}
                />
              </div>
            </div>

            <div>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <Button
                  className="bulk-upload-btn  dynamic-btn-primary"
                  style={customStylesBtnPrimary}
                  type="primary"
                  loading={loading}
                  // onClick={() => goToSuccessImportBulkUpload()}
                  onClick={()=>gotoSelectLenderList()}
                >
                  Next
                </Button>

                <Popconfirm
                  placement="topLeft"
                  title="Your uploaded file will be deleted"
                  onConfirm={onClickCancel}
                  okButtonProps={{
                    style: {
                      backgroundColor: appColors?.appPrimaryColor ?? "#273896",
                      border: "none",
                    },
                  }}
                  cancelButtonProps={{
                    style: {
                      borderColor: appColors?.appSecondaryColor ?? "#C71C8E",
                      color: appColors?.appSecondaryColor ?? "#C71C8E",
                    },
                  }}
                >
                  <Button
                    className="bulk-upload-btn  dynamic-btn-default"
                    style={customStylesBtn}
                  >
                    Back
                  </Button>
                </Popconfirm>
              </div>
            </div>
          </div>
        </div>       
      )}
       {renderLenderListing()}
       {renderLoginUpdateStatus()}
    </>
  );
};

export default BulkupdateMapImport;
